<template>
<div class="row" v-if="!verified">
    <div class="col-12">
        <div class="form-row mb-3">
            <div class="col-12">
                <h5>請驗證閣下的手機號碼，作聯絡領獎用途</h5>
            </div>
        </div>

        <div class="form-row">
            <div class="col-3 mb-3">
            <select name="country_code" class="form-control" v-model="form.country_code">
                <option value="852">+852</option>
                <option value="86">+86</option>
            </select>
            </div>
            <div class="col-9 mb-3">
                <input type="text" name="mobile" class="form-control" placeholder="請輸入手機號碼" v-model="form.mobile">
                <small class="invalid-feedback">
                    請輸入手機號碼
                </small>
            </div>
        </div>

        <div class="form-row">
            <div class="col-8 mb-3">
            <input type="text" name="verify_code" class="form-control" placeholder="請輸入4位數字驗證碼" v-model="form.verify_code" :disabled="!verifyCodeSent" ref="verifyCode">
            </div>
            <div class="col-4 mb-3 text-center">
            <button type="button" class="btn btn-speakout" :disabled="form.mobile == null || form.mobile.length < 8 || countDown < 60" @click="getVerifyCode()">
                <span v-if="countDownTimer != null">{{ countDown }}秒後重發</span>
                <span v-else>獲取驗證碼</span>
            </button>
            </div>
        </div>

        <p class="text-muted"><small>請確保以上號碼正確，我們將發送4位數字驗證碼核實。手機號碼將綁定至您的帳號，可作登入之用。</small></p>

        <div class="form-row">
            <div class="col-12 text-center">
                <button type="button" class="btn btn-block btn-speakout" :disabled="!canClickVerifyButton" @click="checkVerifyCode()">驗證</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'mobile-verification',

    computed: {
        fullMobileNumber() {
            return this.form.country_code + this.form.mobile
        },

        canClickVerifyButton() {
            return this.form.mobile != null && this.form.mobile.length >= 8 && this.verifyCodeSent && this.form.verify_code != null && this.form.verify_code.length == 4
        }
    },

    data() {
        return {
            'form': {
                'country_code': '852',
                'mobile': null,
                'verify_code': null,
            },
            'requestId': null,
            'verifyCodeSent': false,
            'verified': false,
            'countDown': 120,
            'countDownTimer': null
        }
    },

    methods: {
        async getVerifyCode() {
            try {
                const { data, status } = await axios.post(`/mobile-verification/request`, {
                    'mobile': this.fullMobileNumber
                });

                if (status == 200) {
                    // start count down, still keep button disabled
                    this.verifyCodeSent = true
                    this.requestId = data.request_id
                    this.triggerVerficationCountDown()

                    setTimeout(() => {
                        this.$refs.verifyCode.focus()
                    }, 500)
                }
            } catch (error) {
                const { response } = error;

                if (response.status == 409) {
                    alert('手機號碼已被使用')

                    return
                }
                alert('發生未知錯誤，請稍後再試！')
            }
        },

        async checkVerifyCode() {
            try {
                const { data, status } = await axios.post(`/mobile-verification/verify`, {
                    'request_id': this.requestId,
                    'mobile': `+${this.form.country_code}${this.form.mobile}`,
                    'code': this.form.verify_code
                });

                if (status == 200) {
                    this.verified = true

                    this.$emit('mobileVerified', `+${this.form.country_code}${this.form.mobile}`)
                }
            } catch (error) {
                alert('發生未知錯誤，請稍後再試！')
            }
        },

        triggerVerficationCountDown() {
            this.countDownTimer = setInterval(() => {
                --this.countDown;
            }, 1000);
        },
    },

    watch: {
        countDown(newVal, oldVal) {
            if (newVal <= 0) {
                clearInterval(this.countDownTimer)

                this.countDownTimer = null
                this.countDown = 120
            }
        }
    }
}
</script>

<style>

</style>
